<template>
  <div>
    <transition
      v-if="loadingState >= 1 && $root.$store.state.project"
      name="fade"
    >
      <div
        class="project"
      >
        <component
          @mounted="loadingState = 2"
          path="/"
          :is="$store.getters.type"
          v-bind="$store.getters.props"
        />
      </div>
    </transition>
    <div
      v-if="loadingState >= 2 && !$root.$store.state.project"
      class="disconnected"
    >
      Nicht verbunden
    </div>
    <transition
      v-if="loadingState < 2"
      name="fade"
    >
      <spinner>
        Wird geladen...
      </spinner>
    </transition>
  </div>
</template>

<script>
import createStore from '@/store/tree'
import router from '@/router/tree'
import cache from '@/cache'
import Spinner from '@/components/ui/Spinner'
import websocketPlugin from '@/store/websocket-plugin'

export default {
  name: 'ProjectLoader',
  store: createStore([websocketPlugin]),
  router,
  provide () {
    return {
      $cache: this.cache
    }
  },
  components: {
    Spinner
  },
  data () {
    return {
      cache: cache,
      loadingState: 0
    }
  },
  props: {
    project: {
      type: String,
      required: true
    }
  },
  async mounted () {
    await this.$store.loadProject(this.project)
    this.loadingState = 1
    window.addEventListener('keydown', (e) => {
      if (e.key === 'F2') {
        this.$root.$store.dispatch('toggleEditMode')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.disconnected {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: 2em;
}
</style>
